<template>
    <div class="text-editor">
        <div class="editor-btn-div" v-if="modCond">
            <div>
                <button type="button" @click="editor.chain().focus().toggleBold().run()" :class="{'is-active':editor.isActive('bold')}"><BIconTypeBold/></button>
                <button type="button" @click="editor.chain().focus().toggleUnderline().run()" :class="{'is-active':editor.isActive('underline')}"><BIconTypeUnderline/></button>
                <button type="button" @click="editor.chain().focus().toggleItalic().run()" :class="{'is-active':editor.isActive('italic')}"><BIconTypeItalic/></button>
                <button type="button" @click="editor.chain().focus().toggleStrike().run()" :class="{'is-active':editor.isActive('strike')}"><BIconTypeStrikethrough/></button>
                <button type="button" @click="editor.chain().focus().setColor(settingColor).run();" :style="colorBtnStyle()"><BIconType/></button>
                <input
                    type="color"
                    id="colorInput"
                    @input="selectColor($event.target.value)"
                    style="position:absolute; visibility: hidden; left:80px;"
                />
                <button type="button" @click="openColorInput()" class="subBtn" ><BIconCaretDownFill/></button>
                <button type="button" @click="editor.chain().focus().toggleSuperscript().run()" :class="{'is-active':editor.isActive('superscript')}"><BIconSuperscript/></button>
                <button type="button" @click="editor.chain().focus().toggleSubscript().run()" :class="{'is-active':editor.isActive('subscript')}"><BIconSubscript/></button>
            </div>

            <div>
                <button type="button" @click="editor.chain().focus().toggleHeading({level:1}).run()" :class="{'is-active':editor.isActive('heading', {level:1})}" ><BIconTypeH1/></button>
                <button type="button" @click="editor.chain().focus().toggleHeading({level:2}).run()" :class="{'is-active':editor.isActive('heading', {level:2})}" style="font-size:18px;"><BIconTypeH2/></button>
                <button type="button" @click="editor.chain().focus().toggleHeading({level:3}).run()" :class="{'is-active':editor.isActive('heading', {level:3})}" style="font-size:15px;"><BIconTypeH3/></button>
            </div>

            <div>
                <button type="button" @click="editor.chain().focus().setTextAlign('left').run()" :class="{'is-active':editor.isActive({textAlign:'left'})}"><BIconTextLeft/></button>
                <button type="button" @click="editor.chain().focus().setTextAlign('center').run()" :class="{'is-active':editor.isActive({textAlign:'center'})}"><BIconTextCenter/></button>
                <button type="button" @click="editor.chain().focus().setTextAlign('right').run()" :class="{'is-active':editor.isActive({textAlign:'right'})}"><BIconTextRight/></button>
                <!--<button type="button" @click="editor.chain().focus().setTextAlign('justify').run()" :class="{'is-active':editor.isActive({textAlign:'justify'})}"><BIconJustify/></button>-->
                <button type="button" @click="editor.chain().focus().toggleOrderedList().run()" :class="{'is-active':editor.isActive('orderedList')}"><BIconListOl/></button>
                <button type="button" @click="editor.chain().focus().toggleBulletList().run()" :class="{'is-active':editor.isActive('bulletList')}"><BIconListUl/></button>
            </div>

            <div>
                <button @click="triggerImageUpload"><BIconImage /></button>
                <input type="file" ref="imageInput" @change="handleImageUpload" accept="image/*" style="display: none" />

                <button @click="triggerFileUpload"><BIconUpload /></button>
                <input type="file" ref="fileInput" @change="handleFileUpload" accept="*" style="display: none" />

                <button type="button" @click="addVideoPlayer()"><BIconYoutube/></button>

            </div>
        </div>
      <editor-content :editor="editor" />
    </div>
</template>

<script setup>
import {defineProps, ref, onMounted, defineExpose, watch} from "vue";
import {
    BIconTypeBold, BIconTypeItalic, BIconTypeStrikethrough, BIconTypeUnderline, BIconType, BIconCaretDownFill
    , BIconTextCenter, BIconTextRight, BIconTextLeft, BIconJustify
    , BIconSubscript, BIconSuperscript, BIconListOl, BIconListUl ,BIconUpload
    , BIconTypeH1, BIconTypeH2, BIconTypeH3, BIconYoutube , BIconImage
} from "bootstrap-icons-vue";
import {Editor, EditorContent} from '@tiptap/vue-3';
import { Color } from '@tiptap/extension-color';
import Document from '@tiptap/extension-document';
import Heading from '@tiptap/extension-heading';
import Paragraph from '@tiptap/extension-paragraph';
import Text from '@tiptap/extension-text';
import TextStyle from '@tiptap/extension-text-style';
import Bold from '@tiptap/extension-bold';
import Underline from '@tiptap/extension-underline';
import Italic from '@tiptap/extension-italic';
import Strike from '@tiptap/extension-strike';
import Subscript from '@tiptap/extension-subscript';
import Superscript from '@tiptap/extension-superscript';
import TextAlign from '@tiptap/extension-text-align';
import ListItem from '@tiptap/extension-list-item';
import OrderedList from '@tiptap/extension-ordered-list';
import BulletList from '@tiptap/extension-bullet-list';
import Youtube from '@tiptap/extension-youtube';
import Image from '@tiptap/extension-image';
import Link from '@tiptap/extension-link'
import axios from "@/composables/Axios";
import {setting} from "@/setting";
import {useStore} from "vuex";
import Entity from "@/entity/OperationEntity";
import {StarterKit} from "@tiptap/starter-kit";

const store = useStore(),
    tachoUrl = store.state.api.tacho;
const props = defineProps({
  modCond: Boolean,
})
const imageInput = ref(null)
const fileInput = ref(null)
let editor = new Editor({
    extensions: [
        //StarterKit,
        Document,
        Heading.configure({
            levels: [1,2,3]
        }),
        Paragraph,
        Text,
        TextStyle,
        Color,
        Bold,
        Underline,
        Italic,
        Strike,
        Subscript,
        Superscript,
        Image,
        Link.configure({
          openOnClick: false,   // 클릭 시 새 창으로 열기 여부
        }),
        StarterKit,
        TextAlign.configure({
            types: ['heading','paragraph'],
            alignments: ['left', 'right', 'center'],
        }),
        ListItem,
        OrderedList,
        BulletList,
        Youtube.configure({
            width: '95%',
        }),
    ],
    content: '',
    editable: true,
})

const fileName = ref ("");
const settingColor = ref("#ff0000");

const colorBtnStyle = () => {
    return {
        color: settingColor.value
    };
}

const selectedFile = (e) => {
  //파일 선택
  // if (e.target.files[0] && e.target.files[0].type !== "text/csv"){    // 확장자 체크
  //   alert("csv 파일만 업로드가 가능합니다.");
  //   fileName.value = "";
  //   emit('close');
  //   return;
  // }
  // let uploadData = e.target.files[0].name.split('.csv');
  // if (uploadData.length == 0 ){                                       // 파일명 유효성 체크
  //   alert("파일명을 확인해주세요.");
  //   fileName.value = "";
  //   emit('close');
  //   return;
  // }
  // let uploadName = uploadData[0];
  // const nameRex = /^[ㄱ-ㅎ가-힣a-zA-Z0-9_]+$/;
  // if (uploadName && !nameRex.test(uploadName)){                          // 파일명 내용 체크
  //   alert("숫자, 한글, 영문, 특수문자(_)외 파일명은 업로드가 불가합니다.");
  //   fileName.value = "";
  //   emit('close');
  //   return;
  // }

  fileName.value = e.target.files[0];
}
const openColorInput = () => {
    document.getElementById('colorInput').click();
}

const selectColor = (color) => {
    settingColor.value = color;
    editor.chain().focus().setColor(color).run();
}

const getTextHtml = () => {
    return editor.getHTML();
}
const getTextJson = () => {
    return editor.getJSON();
}
const setText = (str) => {
    editor.commands.setContent(str);
}
const setEditable = (state) => {    
    editor.setEditable(state);
}

const addVideoPlayer = () => {
    const url = prompt('Enter YouTube URL');
    if( url != null ) {

        if( url.indexOf('shrots') > -1 ) {
            alert('youTube shorts는 사용 할 수 없습니다.');
            return;
        }

        editor.commands.setYoutubeVideo({
            src: url
        });
    }
}

defineExpose({ getTextHtml, getTextJson, setText, setEditable });

const shortsCheck = (str, findText) => {
    let ifCount = 0,
    ifCountStr = str,
    ifCheck = true;
    while( ifCheck ) {
        let index = ifCountStr.indexOf(findText);
        if(index > -1) {
            ifCountStr = ifCountStr.substring(index+1);
            ifCount++;
        }
        else {
            ifCheck = false;
        }
    }

    return ifCount;
}

watch( ()=>editor.getHTML(), (after, before)=> {

} )

onMounted(() => {
  
});

function triggerFileUpload() {
  if (fileInput.value && typeof fileInput.value.click === 'function') {
    fileInput.value.click();
  } else {
    console.warn('fileInput is not ready yet.')
  }
}
function triggerImageUpload() {
  if (imageInput.value && typeof imageInput.value.click === 'function') {
    imageInput.value.click();
  } else {
    console.warn('imageInput is not ready yet.')
  }
}

function handleImageUpload (event) {
  // 이미지 업로드 경로 확인하기
  const entity = new Entity.organizationHeaders(store.state.sign['userInfo'].userId);
  const file = event.target.files[0];

  if(file.size >  (100 * 1024 * 1024) ){
    alert("100MB 이상의 파일은 업로드할수 없습니다");
    return;
  }

  const formData = new FormData();
  formData.append("file",file);

  if (!file) return

  const header = { "Content-Type" : "multipart/form-data", "user_id" :entity.user_id };

  const res = axios.$post(`${tachoUrl}notice/image-file`, formData, {headers: header});
  res.then((response)=>{
    let fileUrl = response.data.data.taxiFile.url;
    editor
        .chain()
        .insertContent({
          type: 'image',
          attrs: {
            src: process.env.NODE_ENV === 'production' ? fileUrl.replace("http://","https://") : fileUrl,
          },
        })
        .run()
  })

}
function handleFileUpload (event) {

  const entity = new Entity.organizationHeaders(store.state.sign['userInfo'].userId);
  const file = event.target.files[0];
  // 이미지 업로드 경로 확인하기
  if (!event) return;

  let header = entity.get();
  header['Content-Type'] = 'multipart/form-data';
  const formData = new FormData();

  if(file.size > (100 * 1024 * 1024) ){
    alert("100MB 이상의 파일은 업로드할수 없습니다");
    return;
  }
  formData.append("file", file);
  formData.append("user_id", entity.user_id);
  formData.append("trace_id", entity.trace_id);

  const res = axios.$post(`${tachoUrl}notice/image-file`, formData, {headers: header});

  res.then((response)=>{
    let fileUrl = response.data.data.taxiFile.url;
    editor
        .chain()
        .insertContent({
          type: "paragraph",
          content: [
            {
              type: "text",
              text: file.name,
              marks: [
                {
                  type: "link",
                  attrs: {
                    href: process.env.NODE_ENV === 'production' ? fileUrl.replace("http://","https://") : fileUrl,
                    target: "_blank",
                  },
                },
              ],
            },
          ],
        })
        .run()
  })


}
</script>
<style scoped>
.text-editor :deep(span) {
    margin: 0;
    cursor: auto;
}
.text-editor :deep(.tiptap.ProseMirror) {
    height: 50vh ;
    padding: 10px;
    border-top: 1px solid #bbb;
    border-bottom: 1px solid #bbb;
    overflow-y: scroll;
}
.text-editor :deep(.tiptap.ProseMirror > p) {
    margin:0 !important;
}
.editor-btn-div {
    width: 100%;
    height: 36px;
    padding: 3px;
    border-top: 1px solid #bbb;
    background-color: #eeeeee;
    margin-bottom: 0;
}
.editor-btn-div>div {
    float:left;
    margin-right:10px;
    border: 1px solid #aaaaaa;
    border-radius: 5px;
    overflow: hidden;
    background-color: white;
    position: relative;
}
.editor-btn-div button{
    width: 27px;
    height: 27px;
    font-size:23px;
    border: 1px solid #dddddd;
    line-height:23px;
    float:left;
}
.editor-btn-div button.subBtn {
    font-size:8px;
    width: 10px;
    color: #888;
}
.is-active {
    background-color: #ddd;
}

</style>